import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumberPipe',
})
export class PhoneNumberPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;

    const areaCode = value.substring(0, 3);
    const coCode = value.substring(3, 6);
    const line = value.substring(6);

    return `(${areaCode}) ${coCode}-${line}`;
  }
}
